import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Error404Title } from '@constants/titles';

@Component({
    selector: 'health',
    templateUrl: 'health.component.html',
    styleUrls: ['health.component.scss'],
    standalone: false
})
export class HealthComponent {}
